export default __webpack_public_path__ + "static/media/2.86e83a0e.jpg";